// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__34uMH","additionalInfo":"AgreementModal_additionalInfo__2-KqM"};